<template>
  <div class="clients_list">
    <div
        class="main_filters"
        :class="(filters_state)? 'main_fiters_toggler--active' : 'main_fiters_toggler'"
        @click="toggleFiltersState"
    >
      <span
          class="mdi"
          :class="(filters_state)? 'mdi-filter-remove' : 'mdi-filter'"
          @click="toggleFiltersState"
      />
      <span class="main_fiters_toggler_text">
        {{ (filters_state)? translate('filter.hide') : translate('filter.show') }}
      </span>
    </div>

    <div class="wrap-device-list_bg">
      <div class="header" :class="filters_state === true ? 'shown' : 'hidden'">
        <div class="filters">
          <div class="filter form_search">
            <fg-input
                v-model="filter.searched_client"
                type="text"
                class="search_user"
                :placeholder="translate('search')"
                :clearable="true"
            />
          </div>

          <div class="filter form_select">
            <tree-select
                :options="edo_list"
                :multiple="false"
                v-model="filter.edo_id"
                :placeholder="translate('client.edo_type')"
                :clearable="true"
            />
          </div>

          <div class="filter form_select">
            <tree-select
                :options="client_states"
                :multiple="false"
                v-model="filter.client_state"
                :placeholder="translate('client.state')"
                :clearable="false"
            />
          </div>
          <div class="filter"></div>
          <div class="filter"></div>
        </div>

        <div class="buttons">
        <span
            v-if="$store.getters.getPermissions.createClient === true"
            class="mdi mdi-plus-circle-outline btn btn-success btn-fill"
            @click.prevent="create_client()"
        >
        <b>{{ translate('client.to_add') }}</b>
      </span>
        </div>
      </div>
    </div>

    <div class="response_table">
      <table>
        <thead style="height: 50px; flex:0; display: inline-block">
          <tr>
            <th scope="col">
              {{ translate('client.main_info.name') }}
            </th>
            <th scope="col">
              {{ translate('client.main_info.ur_name') }}
            </th>
            <th scope="col">
              {{ translate('client.main_info.city') }}
            </th>
            <th scope="col" class="w180 inn">
              {{ translate('client.main_info.inn') }}
            </th>
            <th scope="col" class="w180 edo">
              {{ translate('client.main_info.edo') }}
            </th>
            <th scope="col" class="w180">
              {{ translate('client.main_info.create') }}
            </th>
            <th scope="col" class="w100">
              {{ translate('client.main_info.status') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <router-link
            :to="'/client/' + client.id"
            v-for="(client,key) in clients_list"
            :key="key"
            class="client link"
            :class="{has_child: client.hasChilds}"
          >
            <tr>
              <td :data-label="translate('client.main_info.name')" class="name">
                <span class="level" v-for="index in client.level" :key="index"/>
                {{ client.name }}
                <i :class="{'mdi mdi-crown': client.root}"/>
              </td>
              <td :data-label="translate('client.main_info.ur_name')">
                {{ client.ur_name }}
              </td>
              <td :data-label="translate('client.main_info.descr')">
                {{ client.city }}
              </td>
              <td :data-label="translate('client.main_info.inn')" class="w180 inn">
                {{ client.inn }}
              </td>
              <td :data-label="translate('client.main_info.edo')" class="w180 edo">
                {{ get_edo(client.edo_id) }}
              </td>
              <td :data-label="translate('client.main_info.create')" class="w180">
                {{ get_date(client.ts_create, ts_date_options) }}
              </td>
              <td :data-label="translate('client.main_info.status')" class="w100">
                <span class="mdi" :class=" client.active > 0 ? 'mdi-check-circle-outline' : 'mdi-checkbox-blank-circle-outline'"></span>
              </td>
            </tr>
          </router-link>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import AddClient from "../../Modal/AddClient.vue";

export default {
  name: 'Client_list',
  components: {
  },
  data () {
    return {
      filter:{
        searched_client: '',
        client_state: "active",
        edo_id: null,
      },

      check_link: true,
      ts_date_options:{
          hour12: false,
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
      },
      clients: [],
      filters_state: (this.localStorage.getItem('filters_state') !== null) ? (this.localStorage.getItem('filters_state') === 'true') : true,
    }
  },

  activated () {
    this.get_client_list()
  },

  watch:{
    "filter.edo_id":{
      handler(){
        this.filter.edo_id = this.filter.edo_id === undefined ? null : this.filter.edo_id
      }
    }
  },

  computed:{
    edo_list(){
      return this.$store.getters.getClientEdoSystems.map((system) => {
        return { id: system.id, label: system.title }
      })
    },
    clients_list() {
      let new_client_list = JSON.parse(JSON.stringify(this.clients))

      if (this.filter.searched_client !== '') {
        new_client_list = new_client_list.filter((client) => {
          if (client.name.toLowerCase().indexOf(this.filter.searched_client.toLowerCase()) > -1 || //Проверка имени в нижнем регистре
              client.ur_name.toLowerCase().indexOf(this.filter.searched_client.toLowerCase()) > -1 || //Проверка логина в нижнем регистре
              client.city?.toLowerCase().indexOf(this.filter.searched_client.toLowerCase()) > -1 ||  //Проверка почты в нижнем регистре
              client.inn.toLowerCase().indexOf(this.filter.searched_client.toLowerCase()) > -1 //Проверка Телефона в нижнем регистре
          ) {
            return client
          }
        })
      }

      if (this.filter.client_state !== "all") {
        new_client_list = new_client_list.filter((client) => {
          if (client.active === 1 && this.filter.client_state === "active") {
            return client
          } else if (client.active === 0 && this.filter.client_state === "blocked"){
            return client
          }
        })
      }

      if (this.filter.edo_id !== null) {
        new_client_list = new_client_list.filter((client) => {
          if (client.edo_id === this.filter.edo_id) {
            return client
          }
        })
      }

      return new_client_list
    },
    client_states() {
      return [
        { label: "all", id: "all" },
        { label: "active", id: "active" },
        { label: "blocked", id: "blocked" },
      ];
    },
  },

  methods: {
    get_edo(edo_id){
      const main_edo = this.$store.getters.getClientEdoSystems.find(item => {
        if (item.id === edo_id) return item
      })
      return main_edo ? main_edo.title : ""
    },
    get_client_list(){
      this.$http.v1.getClients((response) => {
        this.clients = response.data
      })
    },
    create_client(){
      let t = this.$createElement(AddClient, {
        props: {},
        on: {
          close: () => {
            this.$modal.hide('client_order_modal')
            this.check_link = true
          },
          update: () => {
            this.$store.dispatch('clientsListUpdate')
            this.load_client_orders()
          }
        }
      })
      let temp = { render() { return t } }
      this.$modal.show(temp, {}, {
        height: 'auto',
        width: 1000,
        adaptive: true,
        clickToClose: true,
        name: 'client_order_modal'
      })
    },
    toggleFiltersState () {
      this.filters_state = !this.filters_state
      this.localStorage.setItem('filters_state', this.filters_state)
    },
  }
}
</script>

<style lang="scss" scoped>
  .clients_list{
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;

    .main_filters{
      top: 20px;
    }

    .header{
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      flex: 1;
      .filters{
        display: flex;
        justify-content: flex-start;
        width: 100%;
        .filter{
          flex: 1;
          margin-right: 10px;
          &:last-child{
            margin-right: 0;
          }
        }
      }
      .form_search{
        .search_user{
          width: 100%;
          margin-bottom: 0;
        }
      }
      .form_select{
        .vue-treeselect{
          margin: 0;
        }
      }
    }

    .client{
      cursor: pointer;
      &:hover{
        color: #252422;
        tr{
          background-color: #eee;
        }
      }
    }
    .response_table{
      flex: 10;
      padding: 10px 0 0;
      .level{
        display: inline-block;
        width: 20px;
        height: 100%;
      }
      .w180{
        max-width: 180px;
        width: 180px;
      }
      .w100{
        max-width: 100px;
        width: 100px;
      }
      .has_child{
        background-color: #eee;
        font-weight: bold;
      }
      .name{
        text-align: left;
      }
      .inn{
        text-align: left;
      }
    }
  }

  @media (max-width: 1200px) {
    .clients_list{
      .response_table{
        .w180{
          max-width: none;
          width: auto;
        }
        .w100{
          max-width: none;
          width: auto;
        }
      }
    }
  }

  @media (max-width: 500px){
    .header{
      .form{
        width: 100%;
        .filter{
          min-width: max-content;
          margin: 0 10px;
        }
      }
      .btn{
        b{
          display: none;
        }
        width: 20%;
        min-width: inherit;
      }
      .search_user{
        width: 80%;
      }
    }

  }
</style>
